import { isEmpty } from "ramda";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import { DATE_TYPE } from "enums";
import { useCalendarActions } from "store/CalendarSlice";

const useCalendar = () => {
  const { loadCelebrations, meta } = useCalendarActions();

  const { celebrations } = useSelector((state) => state.CalendarSlice);

  const getPeopleCalendar = async () => {
    if (!isEmpty(celebrations)) {
      return Promise.resolve(celebrations);
    }

    const PER_PAGE = 6;
    const PAGE = 1;

    const peopleParams = {
      anniversaryParams: {
        page: { number: PAGE, size: PER_PAGE },
        filter: {
          calendar: "only-anniversaries",
          "start-date": dayjs().format("YYYY-MM-DD"),
        },
      },
      birthdayParams: {
        page: { number: PAGE, size: PER_PAGE },
        filter: {
          calendar: "only-birthdays",
          "start-date": dayjs().format("YYYY-MM-DD"),
        },
      },
    };

    const loadedPeople = await loadCelebrations(peopleParams);

    return loadedPeople;
  };

  const getPeopleCalendarBirthday = async () => {
    const peopleCalendar = await getPeopleCalendar();
    return peopleCalendar.filter((person) => person.dateType === DATE_TYPE.birthday);
  };

  return {
    loadCelebrations,
    celebrations,
    meta,
    getPeopleCalendar,
    getPeopleCalendarBirthday,
  };
};

export default useCalendar;
